let $toggleButtons = $('[data-toggle-element]');

$toggleButtons.each(function(){
    let targetId = $(this).data('toggle-element');

    $(`#${targetId}`).hide();

    $(this).on('click', function(){
        let targetId = $(this).data('toggle-element');
        $(`#${targetId}`).toggle();
    });
});
